// Shared ticket workflow: Pending → In Progress → Completed → Deployed (+ Closed).
// Older statuses (ready_for_testing, ready_to_deploy, resolved) still exist on old tickets
// and are folded into the nearest stage.

export const STATUS_LABELS = {
  open: 'Pending',
  in_progress: 'In Progress',
  completed: 'Completed',
  ready_for_testing: 'Ready for Testing',
  ready_to_deploy: 'Ready to Deploy',
  deployed: 'Deployed',
  resolved: 'Resolved',
  closed: 'Closed'
};

export const STAGES = [
  { key: 'open', label: 'Pending' },
  { key: 'in_progress', label: 'In Progress' },
  { key: 'completed', label: 'Completed' },
  { key: 'deployed', label: 'Deployed' },
];

const STAGE_OF_STATUS = {
  open: 'open',
  in_progress: 'in_progress',
  completed: 'completed',
  ready_for_testing: 'completed',
  ready_to_deploy: 'completed',
  resolved: 'completed',
  deployed: 'deployed',
  closed: 'closed'
};

export const stageOf = (status) => STAGE_OF_STATUS[status] || 'open';

export const stageIndex = (status) => STAGES.findIndex(s => s.key === stageOf(status));

// The one-tap action that moves a ticket forward
export const NEXT_ACTION = {
  open: { to: 'in_progress', label: 'Start Work' },
  in_progress: { to: 'completed', label: 'Mark Completed' },
  completed: { to: 'deployed', label: 'Mark Deployed' },
};

export const PRIORITIES = ['low', 'medium', 'high', 'critical'];

// assignedTo is an array; very old tickets may still hold a single user or null
export const assigneesOf = (ticket) => [].concat(ticket?.assignedTo || []).filter(Boolean);

export const personName = (u) => (u ? `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.username || '' : '');

// "Ali Khan", "Ali Khan, Sara Ahmed", "Ali Khan +2"
export const assigneeSummary = (ticket, max = 2) => {
  const names = assigneesOf(ticket).map(personName).filter(Boolean);
  if (names.length <= max) return names.join(', ');
  return `${names.slice(0, max - 1).join(', ')} +${names.length - (max - 1)}`;
};
